module.exports = __webpack_public_path__ + "img/beautify6.a495c076.webp";